import { Schema } from '@effect/schema'

export const ContactPerson = Schema.Struct({
  name: Schema.String,
  email: Schema.String,
  phoneNumber: Schema.String,
  title: Schema.String,
})
